import _ from "lodash";

export default function translate(key) {
	if(_.has(window.nezzokontikifrontend_translation, key)){
		return _.get(window.nezzokontikifrontend_translation, key)
	}
	else{
		throw new Error('Invalid key ' + key);
	}
}



// WEBPACK FOOTER //
// ./src/services/translation.js